import React from 'react';
import { Route } from 'react-router-dom';

import StandAloneAuthenticationLayer from './StandAloneAuthenticationLayer';
import { STANDALONE_PAGE_PATH} from '../../constants/paths';

class StandaloneLayout extends React.Component {
  render(){
    return (
      <Route path={STANDALONE_PAGE_PATH} component={StandAloneAuthenticationLayer}/>
    );
  }
}

export default StandaloneLayout;
